import { useLayoutEffect, useState } from 'react';
import { ma } from './ArenaMedia.jsx';
import './ArenaBattleAnimation.css';

const EFFECT_VISUALS = {
  heal: ['heal', 'Лечение', '+'], blood: ['blood', 'Кровотечение', '−'],
  armor: ['shield', 'Защита', ''], reflect: ['reflect', 'Отражение', ''],
  mirror: ['reflect', 'Зеркало', ''], invulnerable: ['shield', 'Неуязвимость', ''],
  cry: ['power', 'Боевой клич', ''], critical: ['power', 'Критический удар', ''],
  suppressed: ['stun', 'Оглушение', ''], scheduled: ['prepare', 'Эффект подготовлен', ''],
  power: ['power', 'Усиление', ''],
  critical_missed: ['muted', 'Без критического удара', ''],
  stun_missed: ['muted', 'Оглушение не сработало', ''],
  invulnerability_missed: ['muted', 'Неуязвимость не сработала', ''],
};

export function ArenaBattleAnimation({ event, boardRef }) {
  const [geometry, setGeometry] = useState(null);
  useLayoutEffect(() => {
    const board = boardRef.current;
    if (!board) return;
    function measure() {
      const bounds = board.getBoundingClientRect();
      const center = element => {
        const rect = element?.getBoundingClientRect();
        return rect ? { x: rect.x + rect.width / 2 - bounds.x - board.clientLeft, y: rect.y + rect.height / 2 - bounds.y - board.clientTop } : null;
      };
      const attacker = event.isMe ? '.battle-zone-player' : '.battle-zone-opponent';
      const defender = event.isMe ? '.battle-zone-opponent' : '.battle-zone-player';
      const from = center(board.querySelector(`${attacker} [data-slot="${event.slot}"]`));
      const target = center(board.querySelector(`${defender} .battle-health`));
      const own = center(board.querySelector(`${attacker} .battle-health`));
      if (from && target && own) setGeometry({ from, target, own, width: board.clientWidth, height: board.clientHeight });
    }
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(board);
    return () => observer.disconnect();
  }, [event, boardRef]);
  if (!geometry) return null;
  const { from, target, own, width, height } = geometry;
  const curve = `M ${from.x} ${from.y} Q ${Math.min(width - 20, (from.x + target.x) / 2 + 55)} ${(from.y + target.y) / 2} ${target.x} ${target.y}`;
  const effects = [...(event.effects || [])];
  const nativeBoost = event.modifier === 'Рывок' ||
    (event.modifier === 'Мощный удар' && event.turn <= 2) ||
    (event.modifier === 'Финальный удар' && event.turn >= 9);
  if (nativeBoost && !effects.some(effect => effect.kind === 'suppressed')) {
    effects.push({ kind: 'power', side: 'attacker', modifier: event.modifier });
  }
  const critical = effects.some(effect => effect.kind === 'critical');
  return <div className={`arena-battle-vfx${critical ? ' arena-battle-vfx-critical' : ''}`} aria-hidden="true" data-turn={event.turn}>
    <svg className="arena-battle-vfx-flight" viewBox={`0 0 ${width} ${height}`}>
      <path className="arena-battle-vfx-trail" d={curve} pathLength="1" />
      <path className="arena-battle-vfx-beam" d={curve} pathLength="1" />
    </svg>
    <span className="arena-battle-vfx-orb" style={{ offsetPath: `path('${curve}')` }} />
    <div className="arena-battle-vfx-impact" style={{ left: target.x, top: target.y }}>
      <i className="arena-battle-vfx-ring" />
      {Array.from({ length: 8 }, (_, index) => <i className="arena-battle-vfx-spark" key={index}
        style={{ '--spark-x': `${Math.cos(index * Math.PI / 4) * 48}px`, '--spark-y': `${Math.sin(index * Math.PI / 4) * 48}px` }} />)}
      <b className="arena-battle-vfx-damage">{event.damage > 0 ? `−${ma(event.damage)}` : 'Блок'}</b>
    </div>
    {effects.map((effect, index) => {
      const [kind, label, sign] = EFFECT_VISUALS[effect.kind] || ['prepare', effect.modifier || 'Эффект', ''];
      const point = effect.side === 'attacker' ? own : target;
      const amount = ['heal', 'blood'].includes(effect.kind) && effect.amount > 0 ? `${sign}${ma(effect.amount)}` : '';
      // Reflection belongs to the defender, but its damage returns to the attacker.
      const returned = ['reflect', 'mirror'].includes(effect.kind) && effect.amount > 0;
      return <div key={index} className={`arena-battle-vfx-effect arena-battle-vfx-${kind}`}
        data-kind={effect.kind} data-side={effect.side}
        style={{ left: point.x, top: point.y, '--effect-delay': `${120 + index * 95}ms`, '--label-top': `${point.y > height / 2 ? -75 - (index % 3) * 22 : 30 + (index % 3) * 22}px` }}>
        <i /><span>{effect.modifier || label}{amount ? ` ${amount}` : ''}</span>
        {returned && <b className="arena-battle-vfx-return" style={{ '--return-x': `${own.x - point.x}px`, '--return-y': `${own.y - point.y}px` }}>−{ma(effect.amount)}</b>}
      </div>;
    })}
  </div>;
}
